import { useState } from "react";
import type { PlotChapter } from "@/types/media";

export default function PlotAccordion({ chapters }: { chapters: PlotChapter[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {chapters.map((chapter, i) => {
        const open = openIndex === i;
        return (
          <div
            key={chapter.title}
            className={`rounded-lg border transition-colors ${
              open ? "border-primary-300 bg-primary-50/40" : "border-background-200/80 bg-background-50"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : i)}
              aria-expanded={open}
              className="w-full flex items-center gap-3 p-4 md:p-5 text-left cursor-pointer"
            >
              <span
                className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md text-sm font-bold transition-colors ${
                  open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                }`}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex-1 font-heading text-sm md:text-base font-bold text-foreground-950">
                {chapter.title}
              </span>
              <i
                className={`text-xl text-foreground-400 transition-transform ${open ? "ri-subtract-line" : "ri-add-line"}`}
              ></i>
            </button>
            {open && (
              <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                <p className="text-sm text-foreground-700 leading-relaxed pl-11">{chapter.content}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}